import React, { Component } from "react";
import {
  Grid,
  Icon,
  Form,
  Menu,
  Label,
  Tab,
  Image,
  Popup,
  Header,
  Input,
  Checkbox,
  Card,
} from "semantic-ui-react";
import { Dropdown } from "formsy-semantic-ui-react";

import { dispatch } from "@rematch/core";
import { toastr } from "react-redux-toastr";
import { source } from "react-aim";

@source({
  mouseEnter: (props, component) =>
    dispatch.app.setHelpContext(props.nameOfHelpText),
})
class SmartIntegration extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toggleButtonState: false,
      buttonPressed: false,
      practiceflowlibrary: "",
    };
  }
  componentWillReceiveProps = (nextProps) => {
    if (
      this.state.practiceflowlibrary !==
      nextProps.selectedPracticeFlowActivity._id
    ) {
      // then only check for toggle value
      if (
        nextProps.selectedPracticeFlowActivity &&
        nextProps.selectedPracticeFlowActivity.integration &&
        Object.keys(nextProps.selectedPracticeFlowActivity.integration)
          .length !== 0 &&
        nextProps.selectedPracticeFlowActivity.integration.label
      ) {
        this.setState({
          toggleButtonState: true,
        });
      } else {
        this.setState({
          toggleButtonState: false,
        });
      }
    }
    if (
      this.state.practiceflowlibrary !==
      nextProps.selectedPracticeFlowActivity._id
    ) {
      this.setState({
        togglebuttonPressed: false,
        practiceflowlibrary: this.props.selectedPracticeFlowActivity._id,
      });
    }
    if (
      nextProps.selectedPracticeFlowActivity &&
      nextProps.selectedPracticeFlowActivity.integration &&
      Object.keys(nextProps.selectedPracticeFlowActivity.integration).length !==
        0 &&
      nextProps.selectedPracticeFlowActivity.integration.label
    ) {
      this.setState({
        selectedIntegrationValue:
          nextProps.selectedPracticeFlowActivity.integration.label,
      });
    } else {
      this.setState({
        selectedIntegrationValue: null,
      });
    }
  };

  toggleChange = async (evt, data) => {
    this.setState({ toggleButtonState: !this.state.toggleButtonState });
    if (
      !data.checked &&
      this.props.selectedPracticeFlowActivity &&
      this.props.selectedPracticeFlowActivity.integration &&
      Object.keys(this.props.selectedPracticeFlowActivity.integration)
        .length !== 0
    ) {
      const payload = {
        ...this.props.selectedPracticeFlowActivity,
      };
      // delete payload["integration"];
      let payloadIntegration = {};

      let selectedActivity = {
        ...this.props.selectedPracticeFlowActivity,
        // smartIntegration: value.value,
        integration: payloadIntegration,
      };

      await dispatch.lifeCycle.removeIntegrationInActivities(selectedActivity);

      toastr.success(
        "Integration removed",
        "Integration removed successfully."
      );
    }
    // checked
  };
  selectedIntegration = async (e, value) => {
    if (value.value === null) {
      return false;
    }
    let payloadIntegration = this.props.selectedAccount.integrations.filter(
      (integration) => integration.id._id === value.value
    );
    payloadIntegration = {
      label: payloadIntegration[0].id.label,
      image: payloadIntegration[0].id.image,
      _id: payloadIntegration[0].id._id,
    };

    let selectedActivity = {
      ...this.props.selectedPracticeFlowActivity,
      smartIntegration: value.value,
      integration: payloadIntegration,
    };
    // await dispatch.lifeCycle.removeIntegrationInActivities(selectedActivity);
    await dispatch.lifeCycle.addintegrationInActivities(selectedActivity);

    toastr.success("Integration added", "Integration added successfully.");
  };

  render() {
    let dropdownOptions = this.props.selectedAccount.integrations.filter(
      (item) => item.isActive
    );
    let emptySelect = [{ text: "Select", value: null }];
    let noValue = [
      {
        text: "No Data Available",
        value: null,
        content: <span className="clr-red">No Data Available</span>,
      },
    ];

    let setkeyValue = dropdownOptions
      ? emptySelect.concat(dropdownOptions)
      : noValue;

    dropdownOptions = dropdownOptions.map((v, i) => {
      v.text = v.id.label;
      v.value = v.id._id;
      return v;
    });
    dropdownOptions = emptySelect.concat(dropdownOptions);

    const { selectedIntegrationValue } = this.state;
    return (
      <Grid
        className="pad_0 formcyForm"
        style={{ "background-color": "white" }}
      >
        <Grid.Row className="mar_t_10">
          <Grid.Column width={8}>
            <span>Smart Activity</span>
            {/* <i className="info circle icon"></i> */}
          </Grid.Column>

          <Grid.Column
            width={2}
            style={{
              "margin-left":
                this.props.page === "configure" ? "-150px" : "-100px",
            }}
          >
            <Checkbox
              toggle
              // disabled={false ? "disabled" : "enabled"}
              disabled={
                this.props.selectedPracticeFlowActivity &&
                this.props.selectedPracticeFlowActivity.activities &&
                this.props.selectedPracticeFlowActivity.activities.length !== 0
                  ? "disabled"
                  : null
              }
              // defaultChecked
              checked={this.state.toggleButtonState}
              name="inte1"
              onChange={(evt, data) => this.toggleChange(evt, data)}
            />
          </Grid.Column>
        </Grid.Row>
        {this.state.toggleButtonState ? (
          <Form className="formcyForm">
            <Grid.Row>
              <Grid.Column width={7} className="mar_tb_5">
                <React.Fragment>
                  <Dropdown
                    // required
                    direction="downward"
                    style={{ "z-index": "999999 !important" }}
                    name="default"
                    value={selectedIntegrationValue}
                    text={selectedIntegrationValue}
                    selection
                    fluid
                    scrolling
                    options={dropdownOptions}
                    placeholder="Select Integration"
                    onChange={(e, value) => {
                      this.selectedIntegration(e, value);
                    }}
                  />
                </React.Fragment>
              </Grid.Column>
            </Grid.Row>
          </Form>
        ) : null}
      </Grid>
    );
  }
}

export default SmartIntegration;
